import React from 'react'
import { useState, useEffect } from 'react'
import { useParams } from "react-router-dom"
import { NavBar } from '../../../components/layout/NavBar';
import './Device.module.css'
import { Services } from '@/services/services';
import { TeltonikaRow } from '@/services/model/teltonika';


export const TeltonikaDevicePage = ({services}: {services: Services}) => {
  const [row, setRow] = useState<TeltonikaRow>()
  let imei = useParams().imei

  useEffect(() => {
    if(imei==='' || imei===undefined) {
      return
    }
    let id = services.teltonika.watcher.get(imei)!.listen((o: TeltonikaRow | undefined) => {
      setRow(o)
    })
    return () => {
      if(id===undefined) {
        return
      }
      services.teltonika.watcher.get(imei)!.remove(id)
    };
  }, [imei])

  useEffect(() => {
    fetch(`/api/schema/teltonika/byimei/${imei}`).then((resp) => {
      return resp.json()
    }).then((data) => {
      if(row === undefined) {
        setRow(data)
      }
    });
  }, [imei])

  return (
    <div id='object-page'>
      <NavBar services={services} />
      <section className='object-page'>
        <h2>Teltonika device by {imei} imei</h2>
        <table>
          <tr>
            <th>Stacyjka (Io239):</th>
            <td>{row?.params?.io239 !== undefined ? (row.params.io239 ? 'on' : 'off') : '-'}</td>
          </tr>
          <tr>
            <th>Napięcie baterii (Io66):</th>
            <td>{row?.params?.io66 !== undefined ? (row.params.io66.toFixed(2)+'V') : '-' }</td>
          </tr>
          <tr>
            <th>Motogodziny (Io900):</th>
            <td>{row?.params?.io900 !== undefined ? (row.params.io900.toFixed(2)+'mth') : '-' }</td>
          </tr>
        </table>
        <p>
        {JSON.stringify(row)}
        </p>
      </section>

    </div>
  );
};
